module.exports = __webpack_public_path__ + "img/getstarted_hero.0d6d0a49.jpg";